"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkEvents = void 0;
var siteEvent_1 = require("../enums/siteEvent");
var SdkEvents = /** @class */ (function () {
    /* @ngInject */
    SdkEvents.$inject = ["$rootScope", "Wix"];
    function SdkEvents($rootScope, Wix) {
        this.$rootScope = $rootScope;
        this.Wix = Wix;
    }
    SdkEvents.prototype.on = function (name, callback) {
        var _this = this;
        return this.Wix.PubSub.subscribe(name, function (res) {
            _this.$rootScope.$apply(function () {
                callback.call(_this, res.data);
            });
        }, false);
    };
    SdkEvents.prototype.onWithPastEvents = function (name, callback) {
        var _this = this;
        return this.Wix.PubSub.subscribe(name, function (res) {
            _this.$rootScope.$apply(function () {
                callback(res.data);
            });
        }, true);
    };
    SdkEvents.prototype.off = function (name, eventId) {
        this.Wix.PubSub.unsubscribe(name, eventId);
    };
    SdkEvents.prototype.broadcast = function (name, data) {
        if (data === void 0) { data = null; }
        this.Wix.PubSub.publish(name, data, false);
    };
    SdkEvents.prototype.broadcastPersistent = function (name, data) {
        if (data === void 0) { data = null; }
        this.Wix.PubSub.publish(name, data, true);
    };
    SdkEvents.prototype.onSiteEvent = function (eventType, callback) {
        var _this = this;
        // Prepare callback function
        var callBackFunc = function (eventData) {
            _this.$rootScope.$apply(function () {
                callback.call(_this, eventData);
            });
        };
        return this.Wix.addEventListener(this.getWixEvent(eventType), callBackFunc);
    };
    SdkEvents.prototype.offSiteEvent = function (eventType, eventId) {
        this.Wix.removeEventListener(this.getWixEvent(eventType), eventId);
    };
    SdkEvents.prototype.getWixEvent = function (eventType) {
        var res;
        switch (eventType) {
            case siteEvent_1.siteEventTypeEnum.EDIT_MODE_CHANGE:
                res = this.Wix.Events.EDIT_MODE_CHANGE;
                break;
            case siteEvent_1.siteEventTypeEnum.PAGE_NAVIGATION:
                res = this.Wix.Events.PAGE_NAVIGATION;
                break;
            case siteEvent_1.siteEventTypeEnum.PUBLIC_DATA_CHANGED:
                res = this.Wix.Events.PUBLIC_DATA_CHANGED;
                break;
            case siteEvent_1.siteEventTypeEnum.COMPONENT_DELETED:
                res = this.Wix.Events.COMPONENT_DELETED;
                break;
            case siteEvent_1.siteEventTypeEnum.STYLE_PARAMS_CHANGE:
                res = this.Wix.Events.STYLE_PARAMS_CHANGE;
                break;
            case siteEvent_1.siteEventTypeEnum.SITE_SCROLL:
                res = this.Wix.Events.SCROLL;
                break;
            case siteEvent_1.siteEventTypeEnum.SETTINGS_UPDATED:
                res = this.Wix.Events.SETTINGS_UPDATED;
                break;
            case siteEvent_1.siteEventTypeEnum.PAGE_NAVIGATION_IN:
                res = this.Wix.Events.PAGE_NAVIGATION_IN;
                break;
            default:
        }
        return res;
    };
    return SdkEvents;
}());
exports.SdkEvents = SdkEvents;
